var _use, _symbol;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetworkInterface(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 85 85",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    width: "1em",
    height: "1em"
  }, props), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#network-interface_svg__a",
    x: 2.5,
    y: 2.5
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "network-interface_svg__a",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#9d5025",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 41.579C0 20.293 17.84 3.157 40 3.157s40 17.136 40 38.422S62.16 80 40 80 0 62.864 0 41.579z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 38.422h80v3.157H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 38.422C0 17.136 17.84 0 40 0s40 17.136 40 38.422-17.84 38.422-40 38.422S0 59.707 0 38.422z",
    fill: "#f58536",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.724 22.008v2.841h3.641v30.303h-3.641v2.841h7.046V22.008h-7.046zm54.552 3.926H22.951v23.775h4.325v4.785h18.863v-4.785h6.809v4.785h8.189v-4.785h6.139V25.934z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.723 29.432h34.098v16.566H27.723V29.432z",
    fill: "#d9a741",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.364 32.045h11.817v11.111H31.364V32.045zm15.458 0h11.817v11.111H46.822V32.045z",
    stroke: "none"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgODUgODUiIGZpbGw9IiNmZmYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjx1c2UgeGxpbms6aHJlZj0iI0EiIHg9IjIuNSIgeT0iMi41Ii8+PHN5bWJvbCBpZD0iQSIgb3ZlcmZsb3c9InZpc2libGUiPjxnIGZpbGw9IiM5ZDUwMjUiIHN0cm9rZT0ibm9uZSI+PHBhdGggZD0iTTAgNDEuNTc5QzAgMjAuMjkzIDE3Ljg0IDMuMTU3IDQwIDMuMTU3czQwIDE3LjEzNiA0MCAzOC40MjJTNjIuMTYgODAgNDAgODAgMCA2Mi44NjQgMCA0MS41Nzl6Ii8+PHBhdGggZD0iTTAgMzguNDIyaDgwdjMuMTU3SDB6Ii8+PC9nPjxwYXRoIGQ9Ik0wIDM4LjQyMkMwIDE3LjEzNiAxNy44NCAwIDQwIDBzNDAgMTcuMTM2IDQwIDM4LjQyMi0xNy44NCAzOC40MjItNDAgMzguNDIyUzAgNTkuNzA3IDAgMzguNDIyeiIgZmlsbD0iI2Y1ODUzNiIgc3Ryb2tlPSJub25lIi8+PHBhdGggZD0iTTEyLjcyNCAyMi4wMDhoMHYyLjg0MWgzLjY0MXYzMC4zMDNoLTMuNjQxdjIuODQxaDcuMDQ2VjIyLjAwOGgtNy4wNDYgMCAwem01NC41NTIgMy45MjZoMC00NC4zMjV2MjMuNzc1aDQuMzI1djQuNzg1aDE4Ljg2M3YtNC43ODVoNi44MDl2NC43ODVoOC4xODl2LTQuNzg1aDYuMTM5VjI1LjkzNGgwIDB6IiBzdHJva2U9Im5vbmUiLz48cGF0aCBkPSJNMjcuNzIzIDI5LjQzMmgwIDM0LjA5OHYxNi41NjZIMjcuNzIzVjI5LjQzMmgwIDB6IiBmaWxsPSIjZDlhNzQxIiBzdHJva2U9Im5vbmUiLz48cGF0aCBkPSJNMzEuMzY0IDMyLjA0NWgwIDExLjgxN3YxMS4xMTFIMzEuMzY0VjMyLjA0NWgwIDB6bTE1LjQ1OCAwaDAgMTEuODE3djExLjExMUg0Ni44MjJWMzIuMDQ1aDAgMHoiIHN0cm9rZT0ibm9uZSIvPjwvc3ltYm9sPjwvc3ZnPg==";
export { SvgNetworkInterface as ReactComponent };